import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';

import { Badge } from 'src/registry/ui/Badge';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export default function BooleanBadge({ booleanField }: { booleanField?: boolean | null }) {
    const { formatMessage } = useIntl();

    return (
        <Badge theme={booleanField ? 'green' : 'red'} className="h-fit">
            <FontAwesomeIcon icon={booleanField ? ICON_MAP.CHECK : ICON_MAP.X_MARK} />
            {formatMessage(booleanField ? generalMessages.yes : generalMessages.no)}
        </Badge>
    );
}
